
define('hbs!app/dashboard/DashboardEntitiesGridView.hbs',['hbs','handlebars'], function(hbs, Handlebars){var t = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<span class=\"report-search\"><input type=\"text\" name=\"searchTxt\" placeholder=\"Search...\" size=30\"/></span>\n";
},"useData":true});Handlebars.registerPartial('app/dashboard/DashboardEntitiesGridView.hbs', t);return t;});
